package org.example.project.login

import androidx.compose.runtime.Composable
import org.example.project.settings.LumaticaCheckbox
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.attributes.value
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.alignItems
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.gap
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
@Suppress("LongParameterList")
fun ZweiFaktorLoginUi(
    setup: Boolean,
    qrCode: String,
    code: String,
    trustedDevice: Boolean,
    loading: Boolean,
    error: Boolean,
    errorText: String,
    onCodeChange: (String) -> Unit,
    onTrustedDeviceChange: (Boolean) -> Unit,
    onSubmit: () -> Unit
) {
    P({ classes(LoginStyles.pwSubtitle) }) {
        Text(
            if (setup) {
                "QR-Code scannen und danach den 6-stelligen Code eingeben."
            } else {
                "Bitte den 6-stelligen Code aus deiner Authenticator-App eingeben."
            }
        )
    }
    if (setup && qrCode.isNotBlank()) {
        Img(src = qrCode, attrs = {
            style { width(220.px); height(220.px) }
        })
    }
    Input(type = InputType.Text, attrs = {
        classes(UnifiedAccessStyles.input)
        placeholder("6-stelliger Code")
        value(code)
        attr("inputmode", "numeric")
        attr("autocomplete", "one-time-code")
        onInput {
            onCodeChange(it.value.filter { char -> char in '0'..'9' }.take(6))
        }
        onKeyDown {
            if (it.key == "Enter" || it.code == "Enter" || it.code == "NumpadEnter") {
                it.preventDefault()
                if (!loading) onSubmit()
            }
        }
    })
    if (!setup) {
        Div({
            style {
                display(DisplayStyle.Flex)
                alignItems(AlignItems.Center)
                gap(10.px)
            }
        }) {
            LumaticaCheckbox(
                checked = trustedDevice,
                onChange = onTrustedDeviceChange,
                enabled = !loading,
                fontSizePx = 16
            )
            Span({ classes(LoginStyles.pwSubtitle) }) {
                Text("Diesem Gerät vertrauen")
            }
        }
    }
    if (error) Div({ classes(LoginStyles.error) }) { Text(errorText) }
}
